import React, { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');
  const toggle = useCallback(() => setLang(l => l === 'en' ? 'ta' : 'en'), []);
  return (
    <LanguageContext.Provider value={{ lang, toggle, isEnglish: lang === 'en' }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
